import { Col, Input, Row } from "reactstrap"
import styles from "./Business.module.scss"
import CustomDropdown from "../../../../../components/common/Dropdown/CustomDropDown"
import SecondaryButton from "../../../../../components/common/SecondaryButton/SecondaryButton"

const Business = () => {
  return (
    <div className="py-3">
      <div className={styles["heading"]}>Business Information</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Company name</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Enter company name" />
            </Col>
          </Row>
          <Row className="g-0">
            <Col xs='12' lg="2">Address:</Col>
            <Col xs='12' lg="4">
              <Input type="textarea" placeholder="Enter address" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Head of Company</Col>
            <Col xs='12' lg="4">
              <div className="border border-subtle-secondary rounded p-2">
                <CustomDropdown title={"Select from dropdown"} muted />
              </div>
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Business Registration number</Col>
            <Col xs='12' lg="4">
              <Input type="text" placeholder="Enter Reg no" />
            </Col>
          </Row>
          <Row className="g-0">
            <Col xs='12' lg="2">ID Upload:</Col>
            <Col xs='12' lg="4">
              <div className="d-flex flex-column gap-2">
                <div>
                  <SecondaryButton name={"Upload Frontside"} /> <span>Uploaded image name</span>
                </div>
                <div>
                  <SecondaryButton name={"Upload Backside"} /> <span>Uploaded image name</span>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">CNIC:</Col>
            <Col xs='12' lg="4">
              <Input placeholder={"Enter CNIC"} />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Phone number:</Col>
            <Col xs='12' lg="4">
              <Input type="number" placeholder="Enter Phone no" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Email:</Col>
            <Col xs='12' lg="4">
              <Input type="text" placeholder="Enter Email" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Country:</Col>
            <Col xs='12' lg="4">
              <div className="border border-subtle-secondary rounded p-2">
                <CustomDropdown title="Enter Country" muted />
              </div>
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">State</Col>
            <Col xs='12' lg="4">
              <div className="border border-subtle-secondary rounded p-2">
                <CustomDropdown title="Choose from dropdown menu" muted />
              </div>
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">City:</Col>
            <Col xs='12' lg="4">
              <div className="border border-subtle-secondary rounded p-2">
                <CustomDropdown title="Choose from dropdown menu" muted />
              </div>
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Area:</Col>
            <Col xs='12' lg="4">
              <div className="border border-subtle-secondary rounded p-2">
                <CustomDropdown title="Choose from dropdown menu" muted />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default Business
